<app-error-detail-table-record-template [error]="error" (errorTypeUpdated)="updateErrorType($event)"
                           (errorSolved)="solveError()" [loadingErrorData]="isLoading" [isSolvingError]="isSolving">
    <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.data"
                           [content]="error!.data"/>
</app-error-detail-table-record-template>
